import { useTransition } from 'react';
import type { RefetchFnDynamic } from 'react-relay';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type UseRefetchTransitionReturn<TQuery = any, TKey = any> = [
  boolean,
  RefetchFnDynamic<TQuery, TKey>,
];

export const useRefetchTransition = <TQuery, TKey>(
  refetch: RefetchFnDynamic<TQuery, TKey>,
): UseRefetchTransitionReturn<TQuery, TKey> => {
  const [isPending, startTransition] = useTransition();

  const handleRefetch = (variables, _, callback) => {
    const refetchFn = () => {
      const normalizedVariables =
        typeof variables === 'function' ? variables() : variables;

      refetch(normalizedVariables, { fetchPolicy: 'network-only' });
      callback && callback();
    };

    startTransition(refetchFn);
  };

  return [isPending, handleRefetch];
};
